import HomeIcon from '@public/images/ackodrive-home.svg'
import BuyCarIcon from '@public/images/ackodrive-buyCar.svg'
import ArticlesIcon from '@public/images/ackodrive-articles-nav.svg'
import CVIcon from '@public/images/ackodrive-cvHome.svg'

export const BOTTOM_NAVIGATION_ITEMS = {
  HOME: 'Home',
  BUY_CAR: 'Buy Car',
  ARTICLES: 'Articles',
}

export const BOTTOM_NAVIGATION_ITEM_PROPERTIES = {
  HOME: {
    title: 'Home',
    url: '/',
    eventName: 'tap_btn_home',
    Icon: HomeIcon,
  },
  BUY_CAR: {
    title: 'Buy Car',
    url: '/cars/',
    eventName: 'tap_btn_collection_menu',
    eventProperties: {
      collection_name: 'cars_page',
    },
    Icon: BuyCarIcon,
  },
  CAR_VALUATION: {
    title: 'Sell Car',
    url: '/used/car-valuation/',
    eventName: 'tap_btn_sell_car',
    eventProperties: {
      entry_point: 'Bottom Nav',
    },
    Icon: CVIcon,
  },
  ARTICLES: {
    title: 'Articles',
    url: '/articles/',
    eventName: 'tap_btn_articles',
    Icon: ArticlesIcon,
  },
}
